import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard der nur System-Admins Zugang gewährt.
 * Leitet auf /403 um wenn der Benutzer nicht berechtigt ist.
 */
export const systemAdminGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.initialized;

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  if (authService.isSystemAdmin()) {
    return true;
  }
  return router.createUrlTree(['/403']);
};

/**
 * Guard der Kuratoren (Qualifizierer/Freigeber von Prüfkriterien) UND System-Admins
 * Zugang gewährt. Leitet auf /403 um wenn der Benutzer nicht berechtigt ist.
 */
export const kuratorOderAdminGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.initialized;

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  if (
    authService.isSystemAdmin() ||
    authService.hasRole('ROLE_PRUEFKRITERIUM_QUALIFIZIERER') ||
    authService.hasRole('ROLE_PRUEFKRITERIUM_FREIGEBER')
  ) {
    return true;
  }
  return router.createUrlTree(['/403']);
};

/**
 * Guard der nur Mandant-Admins (und System-Admins) Zugang gewährt.
 */
export const mandantAdminGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.initialized;

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  if (authService.isMandantAdmin()) {
    return true;
  }
  return router.createUrlTree(['/403']);
};
